<template>
  <div class="privacy">
    <header class="header">

      <section class="menu clearfix">
        <div class="logo">
          <img src="../assets/lp/logo.png" alt="ikude">
        </div>

        <div class="controller">
          <nav>
            <ul class="lp-nav">
              <li><a href="/">TOP</a></li>
            </ul>
          </nav>

        </div>
      </section>

    </header>
    <section class="intro">

      <p>
        本利用規約（以下「本規約」といいます。）は、Goldrush Computing株式会社（以下「当社」といいます。）が提供する位置情報サービス「ikude」（以下「本サービス」といいます。）の利用に関する条件を定めるものです。本サービスを利用するには、本規約の全てに同意いただくことが必要になります。
      </p>


    </section>

    <section>

      <h1>第１条（定義）</h1>

      <p>本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。</p>

      <ul>
        <li>(1) 「ユーザー」とは、本サービスを利用してドライバーの位置情報等を確認するお客様をいいます。</li>
        <li>(2) 「契約企業」とは、本サービスを導入している企業（バイク便、デイサービスなど）をいいます。</li>
        <li>(3) 「ドライバー」とは、契約企業との間の雇用又は業務委託契約によりユーザーに対して荷物の配達、送迎等を行うドライバーをいいます。</li>
        <li>(4) 「スマートフォン等」とは、iPhone、Androidスマートフォン、タブレット、パソコン等のインターネットに接続可能な情報端末をいいます。</li>
        <li>(5) 「ユーザーページ」とは、ユーザーがドライバーの現在地や配達情報を確認するためのWebページをいいます。</li>
        <li>(6) 「ドライバーアプリ」とは、ドライバーが配達リストや配達先を確認するためにスマートフォン等にインストールして利用する本サービスのアプリをいいます。</li>
      </ul>

    </section>


    <section>

      <h1>第２条（サービスの概要）</h1>
      <ol>
        <li>本サービスは、バイク便の配達やデイサービスの送迎時に、ユーザーがドライバーの位置情報等をスマートフォン等で確認できるというものです。ユーザーは、スマートフォン等からユーザーページにアクセスすることで、配達・送迎状況やドライバーの現在地を確認することができます。ドライバーは、ドライバーアプリをスマートフォン等にインストールし、配達・送迎リストや配達先・送迎先を確認することができます。</li>
        <li>当社は、ユーザーと契約企業との間のサービス利用契約、及びドライバーと契約企業との間の雇用契約又は業務委託契約に関与するものではありません。ユーザー及びドライバーは、契約企業との間の契約にもとづき必要な範囲内で本サービスを利用するものとします。</li>
      </ol>

    </section>

    <section>
      <h1>第３条（本規約への同意）</h1>
      <ol>
        <li>ユーザーは、ユーザーページにアクセスすることにより、本規約に同意したものとみなします。</li>
        <li>ドライバーは、ドライバーアプリをスマートフォン等にインストールし、本規約への同意手続きを行うものとします。</li>
      </ol>

    </section>

    <section>
      <h1>第４条（権利帰属）</h1>
      <p>本サービス、ユーザーページ又はドライバーアプリ内の提供コンテンツに関する一切の知的財産権は、当社又は当社にライセンスを許諾している第三者に帰属します。</p>
    </section>

    <section>
      <h1>第５条（保証の否認及び免責）</h1>
      <p>当社は、ユーザーページが全てのブラウザで正常に動作すること及びドライバーアプリが全てのスマートフォン等に対応していることを保証するものではありません。ユーザーページ又はドライバーアプリの利用に供するスマートフォン等のOSのバージョンアップ等に伴い、ユーザーページ又はドライバーアプリの動作に不具合が生じる可能性があることにつき、ユーザー及びドライバーはあらかじめ了承するものとします。当社は、かかる不具合が生じた場合に、当社が行うプログラムの修正等により当該不具合が解消されることを保証するものではありません。</p>
    </section>

    <section>
      <h1>第６条（免責条項）</h1>
      <ol>
        <li>当社は、本サービスを利用したことによりユーザー又はドライバーに直接的又は間接的に発生した損害について、一切の賠償責任を負いません。</li>
        <li>当社は、本サービスの利用に関して契約企業とユーザー又はドライバーの間に生じた紛争、及びユーザーとドライバーの間に生じた紛争について一切関与せず、いかなる責任も負いません。</li>
        <li>当社は、ドライバーが本サービス又はドライバーアプリを利用中に事故を起こした場合、一切責任を負いません。</li>
      </ol>
    </section>

    <section>
      <h1>第７条（禁止行為）</h1>
      <p>ユーザー及びドライバーは、本サービス、ユーザーページ又はドライバーアプリを利用するにあたり、以下の各号のいずれかに該当する行為又は該当すると当社が判断する行為をしてはなりません。</p>
      <ol>
        <li>本サービスを契約企業との間の契約の範囲を超えて利用する行為</li>
        <li>本サービスのネットワーク又はシステム等に不正にアクセスし、又は不正なアクセスを試みる行為</li>
        <li>ドライバーアプリを逆アセンブル、逆コンパイル、リバースエンジニアリング等、又はその他ドライバーアプリのソースコード、構造、アイディア等を解析するような行為</li>
        <li>ドライバーアプリを複製、改変、翻案等し、又は他のソフトウェアと結合等する行為</li>
        <li>ドライバーアプリに組み込まれているセキュリティデバイス又はセキュリティコードを破壊するような行為</li>
        <li>ドライバーアプリに付されている著作権表示及びその他の権利表示を除去又は変更する行為</li>
        <li>本サービスの運営を妨害するおそれのある行為</li>
        <li>当社、契約企業、ユーザー又はドライバー、その他の第三者に対する詐欺又は強迫行為</li>
        <li>当社、契約企業、ユーザー又はドライバー、その他の第三者の権利を侵害する行為</li>
        <li>本サービスを通じて知り得たユーザー又はドライバーの個人情報を漏洩する行為</li>
        <li>反社会的勢力等への利益供与</li>
        <li>法令に違反する行為又は犯罪に関連する行為</li>
        <li>その他、当社が不適切と判断する行為</li>
      </ol>
    </section>

    <section>
      <h1>第８条（本サービスの変更・中断・終了等）</h1>
      <h2>１　当社は、ユーザー及びドライバーに事前に通知することなく、本サービスの内容の全部又は一部を変更又は追加することがあります。</h2>
      <h2>２　当社は、以下の各号の事由が生じた場合には、ユーザー及びドライバーに事前に通知することなく、本サービスの全部又は一部を一時的に中断することがあります。</h2>
      <ul>
        <li>(1) 本サービス用の通信機器設備等に関わるメンテナンスや修理を定期的又は緊急に行う場合</li>
        <li>(2) アクセス過多、その他予期せぬ要因でシステムに負荷が集中した場合</li>
        <li>(3) ユーザー及びドライバーのセキュリティを確保する必要が生じた場合</li>
        <li>(4) 電気通信事業者の役務が提供されない場合</li>
        <li>(5) 地震、水害等の天災、火災、停電、その他の不慮の事故又は戦争、紛争、動乱、暴動、労働争議等の不可抗力により本サービスの提供が困難な場合</li>
        <li>(6) 法令又はこれに基づく措置により本サービスの運営が不能となった場合</li>
        <li>(7) その他前各号に準じ当社が必要と判断した場合</li>
      </ul>
      <h2>３　当社は、本条に基づき当社が行った措置によりユーザー又はドライバーに生じた損害について一切の責任を負いません。</h2>

    </section>



    <section>
      <h1>第９条（規約の変更）</h1>

      <ol>
        <li>当社は、当社の判断において、いつでも本規約の内容を変更又は追加できるものとします。変更後の利用規約は、当社が別途定める場合を除いて、本サービス上又は当社の運営するウェブサイトに掲示します。</li>
        <li>ユーザー又はドライバーが本規約の変更後も本サービスの利用を継続する場合には、変更後の本規約に同意したものとみなされます。</li>
      </ol>
    </section>

    <section>
      <h1>第10条（準拠法及び管轄裁判所）</h1>

      <ol>
        <li>本規約の効力、履行および解釈に関しては日本国法が適用されるものとします。</li>
        <li>本規約に関する紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
      </ol>
    </section>


    <footer class="footer">
      <p class="copy">copyright © Goldrush Computing Inc. All Rights Reserved.</p>

    </footer>
  </div>
</template>

<script>


  import * as VueGoogleMaps from "vue2-google-maps";


  export default {
    name: 'LandingPage',

    components: {},

    data() {
      return {}
    },

    computed: {},

    methods: {
      goHome() {
        this.$router.push({name: 'Home'})
      },
    },

    mounted() {




    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  *, *::before, *::after {
    box-sizing: border-box;
  }

  .privacy {
    color: #707070;
    text-align: left;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }

  h1 {
    font-size: 18px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }

  h2 {
    margin-top: 20px;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }

  section {
    margin-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .menu {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
  }

  section ul {
    padding-left: 20px;
    list-style-type: none;
  }

  .section_number {
    font-weight: bold;
  }


  ::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }

  header {
    width: 100%;
    height: 50px;
    margin: 0 auto;
    padding: 0;
    background-color: #fff;
    /*border-bottom: 1px solid #D6B000;*/

  }


  .logo {
    float: left;
    padding: 0 0 0 0;
  }


  .logo {
    float: left;
    padding: 0 0 0 0;
  }

  .logo img{
    position: absolute;
    margin: -8px 0 0 0;
    width: 128px;
    height: auto;
  }


  /* ナビゲーションエリア */
  .controller {
    float: right;
    margin-top: 14px;
    margin-bottom: 10px;
  }



  /* ナビゲーション */
  .lp-nav {
    float: right;
    margin: 0 20px 0 0;
  }

  .lp-nav li{
    float: left;
    margin: 0 30px 0 0;
    font-size: 18px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: bold;
    list-style: none;
  }

  .lp-nav li a {
    color: #707070;
  }

  .lp-nav li a:hover {
    border-bottom: 2px solid #ffffff;
    padding-bottom: 3px;
    text-decoration: none;
    color: #D2FF00  ;
  }



  .clearfix::after {
    content: '';
    display: block;
    clear: both;
  }


  .footer {
    margin-top: 0;
    background-color: #F1F1F1;
    color: #707070
  }

  .copy {
    padding: 0;
    font-size: 14px;
  }

  .col_1 {
    width: 50%;
  }

  .col_2 {
    width: 50%;
  }




</style>



// WEBPACK FOOTER //
// src/pages/Terms.vue